import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../domain/account-draft.validation';

const selectAccountSettings = (state: RootState) => state.accountSettings;

export const selectDraft = (state: RootState) => selectAccountSettings(state).draft;
export const selectSaveStatus = (state: RootState) => selectAccountSettings(state).saveStatus;
export const selectError = (state: RootState) => selectAccountSettings(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectAccountSettings(state).validationErrors;

export const selectIsSaving = (state: RootState) =>
  selectAccountSettings(state).saveStatus === 'saving';

export const selectAvatarStatus = (state: RootState) => selectAccountSettings(state).avatarStatus;
export const selectAvatarError = (state: RootState) => selectAccountSettings(state).avatarError;

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);
